/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import ManagedEvents from "./ManagedEvents"; // eslint-disable-line no-unused-vars

const ManagedEventsContainer = (props) => {
    return(
       <ManagedEvents/>
    )
};

export default ManagedEventsContainer;
